module.exports = __webpack_public_path__ + "static/5-6afc514e655516ce6dd78115e20f44d8.png";